/**
 * Cross-component "user took over audio" signal.
 *
 * When the user starts a different audio source (e.g. taps an annotation
 * pin in SpeciesView and the annotation audio starts), the active
 * Realtime-Voice session should silence its current response so the two
 * audio streams don't talk over each other.
 *
 * SpeciesView (and any other audio source) emits this event without
 * knowing anything about the voice session — keeps the component
 * dependency-free. useTschaukoSession subscribes when active and runs
 * its cancel + dom-mute path.
 */

const EVENT_NAME = 'tschauko:user-took-over-audio'

export function emitVoiceInterrupt(reason: string): void {
  if (typeof window === 'undefined') return
  try {
    window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { reason } }))
  } catch { /* noop */ }
}

export function subscribeVoiceInterrupt(handler: (reason: string) => void): () => void {
  if (typeof window === 'undefined') return () => {}
  const listener = (e: Event) => {
    const detail = (e as CustomEvent<{ reason?: string }>).detail
    handler(detail?.reason || 'unknown')
  }
  window.addEventListener(EVENT_NAME, listener)
  return () => window.removeEventListener(EVENT_NAME, listener)
}
